<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer une nouvelle grille de salaire</strong>
          </div>
          <b-form>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Libellé" label-for="libelle">
                  <b-form-input
                    id="libelle"
                    type="text"
                    :class="{hasError: errors.libelle !== ''}"
                    v-model="libelle"
                  />
                  <span class="field-error">{{ errors.libelle }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Type salaire" label-for="type_salaire">
                  <b-form-input
                    id="type_salaire"
                    type="text"
                    :class="{hasError: errors.type_salaire !== ''}"
                    v-model="type_salaire"
                  />
                  <span class="field-error">{{ errors.type_salaire }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Nombre de mois de salaire" label-for="nb_mois">
                  <b-form-input
                    id="nb_mois"
                    type="text"
                    :class="{hasError: errors.nb_mois !== ''}"
                    v-model="nb_mois"
                  />
                  <span class="field-error">{{ errors.nb_mois }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Nombre de mois de prime" label-for="nb_mois_prime">
                  <b-form-input
                    id="nb_mois_prime"
                    type="text"
                    :class="{hasError: errors.nb_mois_prime !== ''}"
                    v-model="nb_mois_prime"
                  />
                  <span class="field-error">{{ errors.nb_mois_prime }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Mois de référence" label-for="mois_reference">
                  <b-form-input
                    id="mois_reference"
                    type="text"
                    :class="{hasError: errors.mois_reference !== ''}"
                    v-model="mois_reference"
                  />
                  <span class="field-error">{{ errors.nb_mois }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group>
                  <template slot="label"><b>Module Taux</b></template>
                  <b-form-radio-group
                    id="radio-group-2-1"
                    v-model="hasModuleTaux"
                    name="radio-taux"
                  >
                    <b-form-radio value="true">Oui</b-form-radio>
                    <b-form-radio value="false">Non</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group v-if="showModuleTaux">
                  <b-row>
                    <b-col sm="3">
                      <b-form-group label="TA/T1" label-for="tx_ta">
                        <b-form-input
                          id="tx_ta"
                          type="text"
                          :class="{hasError: errors.tx_ta !== ''}"
                          v-model="tx_ta"
                        />
                        <span class="field-error">{{ errors.tx_ta }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group label="TB/T2" label-for="tx_tb">
                        <b-form-input
                          id="tx_tb"
                          type="text"
                          :class="{hasError: errors.tx_tb !== ''}"
                          v-model="tx_tb"
                        />
                        <span class="field-error">{{ errors.tx_tb }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group label="TC" label-for="tx_tc">
                        <b-form-input
                          id="tx_tc"
                          type="text"
                          :class="{hasError: errors.tx_tc !== ''}"
                          v-model="tx_tc"
                        />
                        <span class="field-error">{{ errors.tx_tc }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group label="TD" label-for="tx_td">
                        <b-form-input
                          id="tx_td"
                          type="text"
                          :class="{hasError: errors.tx_td !== ''}"
                          v-model="tx_td"
                        />
                        <span class="field-error">{{ errors.tx_td }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des grilles de salaire
              </b-button>
              <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from '@/utils/auth'
  import { isEmpty } from "@/utils/fileHelper"

  export default {
    name: "Add",
    data() {
      return {
        libelle: "",
        type_salaire: '',
        nb_mois: '',
        nb_mois_prime: '',
        mois_reference: '',
        hasModuleTaux: false,
        showModuleTaux: false,
        tx_ta: '',
        tx_tb: '',
        tx_tc: '',
        tx_td: '',
        errors: {
          libelle: "",
          type_salaire: '',
          nb_mois: '',
          nb_mois_prime: '',
          mois_reference: '',
          tx_ta: '',
          tx_tb: '',
          tx_tc: '',
          tx_td: ''
        },
      }
    },
    watch: {
      'hasModuleTaux'() {
        if (this.hasModuleTaux !== null) {
          if (this.hasModuleTaux === true || this.hasModuleTaux === 'true') {
            this.showModuleTaux = true;
          } else {
            this.showModuleTaux = false;
          }
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      save() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.libelle = this.libelle;
          dataPost.type_salaire = this.type_salaire;
          dataPost.nb_mois = this.nb_mois;
          dataPost.nb_mois_prime = this.nb_mois_prime;
          dataPost.mois_reference = this.mois_reference;
          dataPost.hasModuleTaux = this.hasModuleTaux
          dataPost.tx_ta = this.tx_ta;
          dataPost.tx_tb = this.tx_tb;
          dataPost.tx_tc = this.tx_tc;
          dataPost.tx_td = this.tx_td;
          this.$axios
            .post("/espaceGestion/produit/gestion-grille", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "La grille de salaire a été bien créée",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack()
            })
            .catch(() => {
              this.$store.commit("IS_LOADING", false);
              this.handleError();
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/produit/gestion-grille"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (isEmpty(this.libelle)) {
          this.errors.libelle = "Le libellé est obligatoire";
          valid = false;
        }
        // if (isEmpty(this.type_salaire)) {
        //   this.errors.type_salaire = "Le type de salaire est obligatoire";
        //   valid = false;
        // }
        if (isEmpty(this.nb_mois)) {
          this.errors.nb_mois = "Le nombre de mois de salaire est obligatoire";
          valid = false;
        }
        if (isEmpty(this.nb_mois_prime)) {
          this.errors.nb_mois_prime = "Le nomnre de mois de prime est obligatoire";
          valid = false;
        }
        if (isEmpty(this.mois_reference)) {
          this.errors.mois_reference = "Le mois de référence est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = "";
        this.errors.type_salaire = "";
        this.errors.nb_mois = "";
        this.errors.nb_mois_prime = "";
        this.errors.mois_reference = "";
        this.errors.tx_ta = "";
        this.errors.tx_tb = "";
        this.errors.tx_tc = "";
        this.errors.tx_td = "";
      },
      handleError() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000
        });
      }
    }
  }
</script>
